import { PagingOptions } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { GetBaseBusinessSuccessResponseInfo } from '@/coreInfrastructureModule/axios/generated/baseBusinessManage';
import { IPagingOptions } from '@/coreDomainsModule/paging';

/**
 * 集計取引編集子取引モーダルに表示する取引情報
 * @param result - 取引情報
 * @param pagingOptions - ページングオプション
 */
export interface IGetEditAggregateBusinessChildResult {
  result: IBusiness[];
  pagingOptions: IPagingOptions;
}

/**
 * 取引編集モーダルで集計編集を行った際の子取引情報アダプタ
 */
export class GetEditAggregateBusinessChildAdapter {
  /**
   *
   * 取得した集計に紐づく子取引をIBusinessに変換する
   * @param response - 在庫管理のAPIから返ってきたデータ
   */
  public static adapt = (response: GetBaseBusinessSuccessResponseInfo): IGetEditAggregateBusinessChildResult => {
    const res: IBusiness[] = [];
    response.data?.forEach((business) => {
      res.push(
        BusinessFactory.create({
          businessId: business.baseBusinessId,
          warehouseNumber: business.warehouseNumber,
          warehouse: business.warehouse,
          supplierNumber: business.supplierNumber,
          supplierName: business.supplierName,
          businessNumber: business.businessNumber,
          businessName: business.businessName,
          package: business.package,
          unit: business.unit,
          manufacturer: business.manufacturer,
          leadTime: business.leadTime,
          leadTimeUnit: business.leadTimeUnit,
          MOQ: business.moq != null ? Number(business.moq) : undefined,
          stdInventoryIndices: {
            標準在庫指数: {
              max: Number(business.standardInventoryIndexMax ?? 0),
              min: Number(business.standardInventoryIndexMin ?? 0),
              option: {
                unit: business.standardInventoryIndexUnit ?? '',
              },
            },
          },
          customerNumber: business.customerNumber,
          customerName: business.customerName,
          salesDestinationNumber: business.salesDestinationNumber,
          salesDestinationName: business.salesDestinationName,
          endUser: business.endUser,
          salesUnitPrice: business.salesUnitPrice != null ? Number(business.salesUnitPrice) : undefined,
          updatedAt: business.updateAt,
        })
      );
    });
    return {
      result: res,
      pagingOptions: { ...(response.pagingOptions as PagingOptions) },
    };
  };
}
